// extracted by mini-css-extract-plugin
export default {"GnsGames":"GnsGames_GnsGames__1v2OI","Logo":"GnsGames_Logo__totAc","Info":"GnsGames_Info__waR3M","Light":"GnsGames_Light__RXtZv"};